// Translations for Viketory E-Bike Catalog
// Languages: Italian (it), English (en), Spanish (es)

export const translations = {
  it: {
    // Header
    nav: {
      catalog: "Catalogo",
      fatbike: "Fatbike",
      mtb: "MTB",
      urban: "Urbane",
      folding: "Fatbike Pieghevoli",
      discoverModels: "Scopri i Modelli"
    },
    
    // Hero Section
    hero: {
      exploreCatalog: "Esplora il Catalogo"
    },
    
    // Brand Info
    brand: {
      title: "Perché Scegliere",
      tagline: "E-Bike di Alta Qualità",
      description: "Le EBIKE VIKETORY sono biciclette elettriche di alta qualità, progettate per soddisfare le esigenze della mobilità moderna. Dotate di tecnologie avanzate, offrono la perfetta combinazione di potenza, autonomia ed efficienza, senza rinunciare allo stile.",
      manufacturer: "Progettate e prodotte dal gruppo internazionale europeo EWheel, dal 2017 sul mercato quale fornitore specializzato in componenti e ricambi per monopattini ed ebike.",
      power: "Potenza",
      powerDesc: "Motori da 42 a 130 Nm per affrontare ogni sfida",
      range: "Autonomia",
      rangeDesc: "Batterie 48V 720Wh per lunghe distanze",
      versatility: "Versatilità",
      versatilityDesc: "Dal commuting urbano ai sentieri più estremi"
    },
    
    // Highlighted Section
    highlighted: {
      title: "Modelli in Evidenza",
      subtitle: "I nostri modelli più popolari, scelti per prestazioni e design eccezionali"
    },
    
    // Catalog Section
    catalog: {
      title: "Catalogo Completo",
      subtitle: "Scopri tutta la gamma di e-bike Viketory: dalle potenti fatbike alle agili pieghevoli"
    },
    
    // Categories
    categories: {
      fatbike: {
        name: "Fatbike",
        description: "Ruote extra larghe per massima stabilità su ogni terreno"
      },
      mtb: {
        name: "Mountain Bike",
        description: "Per chi cerca avventura fuori dall'asfalto"
      },
      urban: {
        name: "Urbane",
        description: "Comfort e praticità per il commuting quotidiano"
      },
      folding: {
        name: "Fatbike Pieghevoli",
        description: "Compatte e versatili, perfette per ogni spazio"
      },
    },
    
    // Product Page
    product: {
      back: "Indietro",
      home: "Home",
      catalog: "Catalogo",
      colorAvailable: "Colore disponibile",
      buyOnStore: "Acquista Subito",
      contactAvailability: "Contattaci per Disponibilità",
      freeShipping: "Prezzo escluso di spedizione, montaggio e preconsegna.",
      preAssembled: "Preassemblate all'80%",
      mainFeatures: "Caratteristiche Principali",
      complianceTitle: "Normative e Omologazioni",
      complianceText: "Tutte le bici Viketory sono omologate secondo le normative europee, con marchio CE e conformità alla normativa EPAC EN15194 per biciclette a pedalata assistita.",
      techSpecs: "Specifiche Tecniche",
      technicalSpecs: "Specifiche Tecniche",
      technicalDetails: "Dettagli Tecnici",
      power: "Potenza",
      haveQuestions: "Hai Domande?",
      contactUs: "Contattaci per maggiori informazioni o per prenotare un test ride",
      bookAppointment: "Prenota Appuntamento",
      salesPoint: "Punto Vendita",
      hours: "Orari",
      otherModels: "Altri modelli",
      modelNotFound: "Modello non trovato",
      modelNotFoundDesc: "Il modello che stai cercando non esiste o è stato rimosso.",
      backToCatalog: "Torna al Catalogo",
      topSeller: "TOP SELLER",
      downloadManual: "Scarica Manuale",
      selectLanguage: "Seleziona Lingua",
      manualAvailable: "Manuale disponibile"
    },
    
    // Specs Labels
    specs: {
      motor: "Motore",
      battery: "Batteria",
      wheels: "Ruote",
      brakes: "Freni",
      gears: "Cambio",
      fork: "Forcella",
      weight: "Peso",
      dimensions: "Dimensioni"
    },
    
    // Footer
    footer: {
      tagline: "E-Bike di Alta Qualità",
      categories: "Categorie",
      usefulLinks: "Link Utili",
      home: "Home",
      fullCatalog: "Catalogo Completo",
      store: "FreeWheel Store",
      bookAppointment: "Prenota Appuntamento",
      contacts: "Contatti",
      allRightsReserved: "Tutti i diritti riservati",
      distributedBy: "Distribuito da"
    },
    
    // Badges
    badges: {
      promo: "PROMO",
      top: "TOP"
    },
    
    // Compare Feature
    compare: {
      title: "Confronta Bici",
      selectBike: "Seleziona una bici",
      searchPlaceholder: "Cerca per nome o categoria...",
      addBike: "Aggiungi Bici",
      viewDetails: "Vedi Dettagli",
      keySpecs: "Specifiche Chiave",
      dimensions: "Dimensioni",
      features: "Caratteristiche",
      selected: "Selezionate",
      clear: "Cancella",
      compareNow: "Confronta",
      add: "Confronta",
      added: "Aggiunto"
    },
    
    // Bikes Content
    bikes: {
      navy: {
        tagline: "Forte, Imponente e Pronta a Tutto",
        description: "NAVY è una fatbike dallo spirito aggressivo e dal design robusto, pensata per chi cerca presenza, stabilità e stile. La sella allungata dona un look distintivo e maggiore comfort.",
        color: "Blu Navy / Bianco",
        features: ["Sella allungata", "Ammortizzatore centrale", "Display LCD colori", "A norma stradale"]
      },
      commando: {
        tagline: "Spirito Aggressivo, Design Robusto",
        description: "COMMANDO è una fatbike di spirito aggressivo e design robusto, pensata per chi cerca presenza, stabilità e stile. Ruote extra larghe e costruzione solida per ogni superficie.",
        color: "Giallo / Bianco - Rosso",
        features: ["Sella customizzata", "Ammortizzatore centrale", "Display LCD colori", "Catena KMC 7V"]
      },
      terram: {
        tagline: "Performance al Top",
        description: "La TERRAM è una e-MTB pensata per chi vuole andare oltre l'uso urbano, combinando comodità, controllo e capacità di affrontare sentieri e piste. Componenti premium RockShox e SRAM.",
        color: "Grigio / Bianco",
        features: ["Ammortizzatore RockShox DELUXE", "Reggisella telescopico 150mm", "Sella SELLE ROYAL", "Motore centrale"]
      },
      roktar: {
        tagline: "MTB Polivalente",
        description: "La ROKTAR è una e-MTB per utenti che cercano un'esperienza polivalente fuori dall'asfalto. Equilibrata e accessibile per godere della montagna senza complicazioni.",
        color: "Rosso/Nero - Nero/Arancio",
        features: ["Display LCD colori", "Sella confortevole", "Catena KMC 8V", "Forcella 160mm"]
      },
      "roktar-plus": {
        tagline: "MTB Polivalente Potenziata",
        description: "La ROKTAR Plus è la versione potenziata della e-MTB Roktar. Motore da 80 Nm per affrontare salite impegnative e sentieri tecnici con maggiore facilità.",
        color: "Rosso/Nero - Nero/Arancio",
        features: ["Motore potenziato 80 Nm", "Display LCD colori", "Sella confortevole", "Forcella 160mm"]
      },
      zhepir: {
        tagline: "Versatilità Totale",
        description: "La ZHEPIR è pensata per chi cerca un'esperienza polivalente tra sentieri tranquilli, piste di terra e uso ricreativo. Guida comoda, stabile e facile da controllare.",
        color: "Verde Militare - Blu",
        features: ["Display LCD colori", "Sella confortevole", "Forcella EXSHO", "2 colori disponibili"]
      },
      "zhepir-plus": {
        tagline: "Versatilità Totale Potenziata",
        description: "La ZHEPIR X+Plus è la versione potenziata della MTB Zhepir. Motore da 80 Nm per affrontare qualsiasi terreno con potenza superiore.",
        color: "Blu - Verde Militare",
        features: ["Motore potenziato 80 Nm", "Display LCD colori", "Sella confortevole", "2 colori disponibili"]
      },
      arenox: {
        tagline: "Eleganza Urbana",
        description: "ARENOX è una ebike urbana che privilegia comodità, facilità d'uso e guida stabile in ambienti urbani. Perfetta per il commuting quotidiano.",
        color: "Perlato - Rame",
        features: ["Design elegante", "Sella confortevole", "2 colori disponibili", "Display LCD colori"]
      },
      "arenox-plus": {
        tagline: "Eleganza Urbana Potenziata",
        description: "ARENOX X+Plus è la versione potenziata della ebike urbana Arenox. Maggiore coppia e prestazioni superiori per chi cerca il massimo comfort in città.",
        color: "Rame - Perlato",
        features: ["Motore potenziato 80 Nm", "Design elegante", "Sella confortevole", "Display LCD colori"]
      },
      ventix: {
        tagline: "Comfort Quotidiano",
        description: "La VENTIX è una ebike urbana pensata per il giorno a giorno, progettata per spostamenti comodi, pratici ed efficienti in città.",
        color: "Grigio/Rosso - Grigio/Blu",
        features: ["Posizione eretta", "Sella confortevole", "2 colori disponibili", "Display LCD colori"]
      },
      "ventix-plus": {
        tagline: "Comfort Quotidiano Potenziato",
        description: "La VENTIX X+Plus è la versione potenziata della ebike urbana Ventix. Maggiore coppia per affrontare salite e tragitti impegnativi con facilità.",
        color: "Grigio/Blu - Grigio/Rosso",
        features: ["Motore potenziato 80 Nm", "Posizione eretta", "Sella confortevole", "Display LCD colori"]
      },
      granit: {
        tagline: "Fatbike Pieghevole",
        description: "GRANIT è una fatbike pieghevole progettata per offrire massima comodità senza rinunciare alla forza. Telaio aperto per salire e scendere facilmente.",
        color: "Bianca",
        features: ["Telaio aperto", "Sistema piegatura rapido", "Sella confortevole", "Fat Tire 20×4"]
      },
      lithor: {
        tagline: "Forza e Praticità",
        description: "LITHOR è una fatbike pieghevole che combina forza, comodità e funzionalità. Domina terreni irregolari come sabbia, neve o sterrato con facilità.",
        color: "Crema - Grigio - Turchese",
        features: ["Sistema piegatura rapido", "Sella confortevole", "Fat Tire 20×4", "Design retrò"]
      },
      brave: {
        tagline: "Avventura Senza Limiti",
        description: "La BRAVE è una fatbike pieghevole con sospensione che porta l'avventura a un altro livello. Comodità, potenza e libertà in un unico design.",
        color: "Arancio / Grigio",
        features: ["Ammortizzatore centrale", "Sistema piegatura", "Sella confortevole", "Full suspension"]
      }
    }
  },
  
  en: {
    // Header
    nav: {
      catalog: "Catalog",
      fatbike: "Fatbike",
      mtb: "MTB",
      urban: "Urban",
      folding: "Folding Fatbike",
      discoverModels: "Discover Models"
    },
    
    // Hero Section
    hero: {
      exploreCatalog: "Explore Catalog"
    },
    
    // Brand Info
    brand: {
      title: "Why Choose",
      tagline: "High Quality E-Bikes",
      description: "VIKETORY E-BIKES are high quality electric bicycles, designed to meet the needs of modern mobility. Equipped with advanced technologies, they offer the perfect combination of power, range and efficiency, without sacrificing style.",
      manufacturer: "Designed and manufactured by the European international group EWheel, on the market since 2017 as a specialized supplier of components and spare parts for scooters and e-bikes.",
      power: "Power",
      powerDesc: "Motors from 42 to 130 Nm to face any challenge",
      range: "Range",
      rangeDesc: "48V 720Wh batteries for long distances",
      versatility: "Versatility",
      versatilityDesc: "From urban commuting to the most extreme trails"
    },
    
    // Highlighted Section
    highlighted: {
      title: "Featured Models",
      subtitle: "Our most popular models, chosen for exceptional performance and design"
    },
    
    // Catalog Section
    catalog: {
      title: "Full Catalog",
      subtitle: "Discover the entire range of Viketory e-bikes: from powerful fatbikes to agile folding bikes"
    },
    
    // Categories
    categories: {
      fatbike: {
        name: "Fatbike",
        description: "Extra wide wheels for maximum stability on any terrain"
      },
      mtb: {
        name: "Mountain Bike",
        description: "For those seeking adventure off the asphalt"
      },
      urban: {
        name: "Urban",
        description: "Comfort and practicality for daily commuting"
      },
      folding: {
        name: "Folding Fatbike",
        description: "Compact and versatile, perfect for any space"
      },
    },
    
    // Product Page
    product: {
      back: "Back",
      home: "Home",
      catalog: "Catalog",
      colorAvailable: "Available color",
      buyOnStore: "Buy Now",
      contactAvailability: "Contact for Availability",
      freeShipping: "Price excludes shipping, assembly and pre-delivery.",
      preAssembled: "80% pre-assembled",
      mainFeatures: "Main Features",
      complianceTitle: "Regulations and Homologation",
      complianceText: "All Viketory bikes are homologated according to European regulations, with CE marking and EPAC EN15194 compliance for pedal-assist bicycles.",
      techSpecs: "Technical Specifications",
      technicalSpecs: "Technical Specifications",
      technicalDetails: "Technical Details",
      power: "Power",
      haveQuestions: "Have Questions?",
      contactUs: "Contact us for more information or to book a test ride",
      bookAppointment: "Book Appointment",
      salesPoint: "Sales Point",
      hours: "Hours",
      otherModels: "Other models",
      modelNotFound: "Model not found",
      modelNotFoundDesc: "The model you are looking for does not exist or has been removed.",
      backToCatalog: "Back to Catalog",
      topSeller: "TOP SELLER",
      downloadManual: "Download Manual",
      selectLanguage: "Select Language",
      manualAvailable: "Manual available"
    },
    
    // Specs Labels
    specs: {
      motor: "Motor",
      battery: "Battery",
      wheels: "Wheels",
      brakes: "Brakes",
      gears: "Gears",
      fork: "Fork",
      weight: "Weight",
      dimensions: "Dimensions"
    },
    
    // Footer
    footer: {
      tagline: "High Quality E-Bikes",
      categories: "Categories",
      usefulLinks: "Useful Links",
      home: "Home",
      fullCatalog: "Full Catalog",
      store: "FreeWheel Store",
      bookAppointment: "Book Appointment",
      contacts: "Contacts",
      allRightsReserved: "All rights reserved",
      distributedBy: "Distributed by"
    },
    
    // Badges
    badges: {
      promo: "SALE",
      top: "TOP"
    },
    
    // Compare Feature
    compare: {
      title: "Compare Bikes",
      selectBike: "Select a bike",
      searchPlaceholder: "Search by name or category...",
      addBike: "Add Bike",
      viewDetails: "View Details",
      keySpecs: "Key Specifications",
      dimensions: "Dimensions",
      features: "Features",
      selected: "Selected",
      clear: "Clear",
      compareNow: "Compare",
      add: "Compare",
      added: "Added"
    },
    
    // Bikes Content
    bikes: {
      navy: {
        tagline: "Strong, Imposing and Ready for Anything",
        description: "NAVY is a fatbike with an aggressive spirit and robust design, designed for those seeking presence, stability and style. The elongated saddle gives a distinctive look and greater comfort.",
        color: "Navy Blue / White",
        features: ["Elongated saddle", "Central shock absorber", "Color LCD display", "Road legal"]
      },
      commando: {
        tagline: "Aggressive Spirit, Robust Design",
        description: "COMMANDO is a fatbike with aggressive spirit and robust design, designed for those seeking presence, stability and style. Extra wide wheels and solid construction for any surface.",
        color: "Yellow / White - Red",
        features: ["Customized saddle", "Central shock absorber", "Color LCD display", "KMC 7V chain"]
      },
      terram: {
        tagline: "Top Performance",
        description: "TERRAM is an e-MTB designed for those who want to go beyond urban use, combining comfort, control and the ability to tackle trails and tracks. Premium RockShox and SRAM components.",
        color: "Grey / White",
        features: ["RockShox DELUXE shock", "150mm dropper post", "SELLE ROYAL saddle", "Central motor"]
      },
      roktar: {
        tagline: "Versatile MTB",
        description: "ROKTAR is an e-MTB for users seeking a versatile off-road experience. Balanced and accessible to enjoy the mountains without complications.",
        color: "Red/Black - Black/Orange",
        features: ["Color LCD display", "Comfortable saddle", "KMC 8V chain", "160mm fork"]
      },
      "roktar-plus": {
        tagline: "Enhanced Versatile MTB",
        description: "ROKTAR Plus is the enhanced version of the Roktar e-MTB. 80 Nm motor to tackle challenging climbs and technical trails with greater ease.",
        color: "Red/Black - Black/Orange",
        features: ["Enhanced 80 Nm motor", "Color LCD display", "Comfortable saddle", "160mm fork"]
      },
      zhepir: {
        tagline: "Total Versatility",
        description: "ZHEPIR is designed for those seeking a versatile experience between quiet trails, dirt tracks and recreational use. Comfortable, stable and easy to control riding.",
        color: "Military Green - Blue",
        features: ["Color LCD display", "Comfortable saddle", "EXSHO fork", "2 colors available"]
      },
      "zhepir-plus": {
        tagline: "Enhanced Total Versatility",
        description: "ZHEPIR X+Plus is the enhanced version of the Zhepir MTB. 80 Nm motor to tackle any terrain with superior power.",
        color: "Blue - Military Green",
        features: ["Enhanced 80 Nm motor", "Color LCD display", "Comfortable saddle", "2 colors available"]
      },
      arenox: {
        tagline: "Urban Elegance",
        description: "ARENOX is an urban e-bike that prioritizes comfort, ease of use and stable riding in urban environments. Perfect for daily commuting.",
        color: "Pearl - Copper",
        features: ["Elegant design", "Comfortable saddle", "2 colors available", "Color LCD display"]
      },
      "arenox-plus": {
        tagline: "Enhanced Urban Elegance",
        description: "ARENOX X+Plus is the enhanced version of the Arenox urban e-bike. More torque and superior performance for those seeking maximum comfort in the city.",
        color: "Copper - Pearl",
        features: ["Enhanced 80 Nm motor", "Elegant design", "Comfortable saddle", "Color LCD display"]
      },
      ventix: {
        tagline: "Daily Comfort",
        description: "VENTIX is an urban e-bike designed for everyday use, designed for comfortable, practical and efficient city trips.",
        color: "Grey/Red - Grey/Blue",
        features: ["Upright position", "Comfortable saddle", "2 colors available", "Color LCD display"]
      },
      "ventix-plus": {
        tagline: "Enhanced Daily Comfort",
        description: "VENTIX X+Plus is the enhanced version of the Ventix urban e-bike. More torque to tackle hills and demanding routes with ease.",
        color: "Grey/Blue - Grey/Red",
        features: ["Enhanced 80 Nm motor", "Upright position", "Comfortable saddle", "Color LCD display"]
      },
      granit: {
        tagline: "Folding Fatbike",
        description: "GRANIT is a folding fatbike designed to offer maximum comfort without sacrificing strength. Open frame for easy mounting and dismounting.",
        color: "White",
        features: ["Open frame", "Quick folding system", "Comfortable saddle", "Fat Tire 20×4"]
      },
      lithor: {
        tagline: "Strength and Practicality",
        description: "LITHOR is a folding fatbike that combines strength, comfort and functionality. Dominates irregular terrain like sand, snow or dirt with ease.",
        color: "Cream - Grey - Turquoise",
        features: ["Quick folding system", "Comfortable saddle", "Fat Tire 20×4", "Retro design"]
      },
      brave: {
        tagline: "Adventure Without Limits",
        description: "BRAVE is a folding fatbike with suspension that takes adventure to another level. Comfort, power and freedom in a single design.",
        color: "Orange / Grey",
        features: ["Central shock absorber", "Folding system", "Comfortable saddle", "Full suspension"]
      }
    }
  },
  
  es: {
    // Header
    nav: {
      catalog: "Catálogo",
      fatbike: "Fatbike",
      mtb: "MTB",
      urban: "Urbanas",
      folding: "Fatbike Plegables",
      discoverModels: "Descubre los Modelos"
    },
    
    // Hero Section
    hero: {
      exploreCatalog: "Explorar Catálogo"
    },
    
    // Brand Info
    brand: {
      title: "Por qué Elegir",
      tagline: "E-Bikes de Alta Calidad",
      description: "Las EBIKE VIKETORY son bicicletas eléctricas de alta calidad, diseñadas para satisfacer las necesidades de la movilidad moderna. Equipadas con tecnologías avanzadas, ofrecen la combinación perfecta de potencia, autonomía y eficiencia, sin renunciar al estilo.",
      manufacturer: "Diseñadas y fabricadas por el grupo internacional europeo EWheel, en el mercado desde 2017 como proveedor especializado en componentes y repuestos para patinetes y e-bikes.",
      power: "Potencia",
      powerDesc: "Motores de 42 a 130 Nm para afrontar cualquier desafío",
      range: "Autonomía",
      rangeDesc: "Baterías 48V 720Wh para largas distancias",
      versatility: "Versatilidad",
      versatilityDesc: "Desde el commuting urbano hasta los senderos más extremos"
    },
    
    // Highlighted Section
    highlighted: {
      title: "Modelos Destacados",
      subtitle: "Nuestros modelos más populares, elegidos por su rendimiento y diseño excepcionales"
    },
    
    // Catalog Section
    catalog: {
      title: "Catálogo Completo",
      subtitle: "Descubre toda la gama de e-bikes Viketory: desde potentes fatbikes hasta ágiles plegables"
    },
    
    // Categories
    categories: {
      fatbike: {
        name: "Fatbike",
        description: "Ruedas extra anchas para máxima estabilidad en cualquier terreno"
      },
      mtb: {
        name: "Mountain Bike",
        description: "Para quienes buscan aventura fuera del asfalto"
      },
      urban: {
        name: "Urbanas",
        description: "Comodidad y practicidad para el commuting diario"
      },
      folding: {
        name: "Fatbike Plegables",
        description: "Compactas y versátiles, perfectas para cualquier espacio"
      },
    },
    
    // Product Page
    product: {
      back: "Atrás",
      home: "Inicio",
      catalog: "Catálogo",
      colorAvailable: "Color disponible",
      buyOnStore: "Comprar ahora",
      contactAvailability: "Contactar por Disponibilidad",
      freeShipping: "Precio excluido de envío, montaje y preentrega.",
      preAssembled: "Preensambladas al 80%",
      mainFeatures: "Características Principales",
      complianceTitle: "Normativas y Homologación",
      complianceText: "Todas las bicis Viketory están homologadas según las normativas europeas, con marcado CE y conformidad EPAC EN15194 para bicicletas de pedaleo asistido.",
      techSpecs: "Especificaciones Técnicas",
      technicalSpecs: "Especificaciones Técnicas",
      technicalDetails: "Detalles Técnicos",
      power: "Potencia",
      haveQuestions: "¿Tienes Preguntas?",
      contactUs: "Contáctanos para más información o para reservar una prueba",
      bookAppointment: "Reservar Cita",
      salesPoint: "Punto de Venta",
      hours: "Horarios",
      otherModels: "Otros modelos",
      modelNotFound: "Modelo no encontrado",
      modelNotFoundDesc: "El modelo que buscas no existe o ha sido eliminado.",
      backToCatalog: "Volver al Catálogo",
      topSeller: "MÁS VENDIDO",
      downloadManual: "Descargar Manual",
      selectLanguage: "Seleccionar Idioma",
      manualAvailable: "Manual disponible"
    },
    
    // Specs Labels
    specs: {
      motor: "Motor",
      battery: "Batería",
      wheels: "Ruedas",
      brakes: "Frenos",
      gears: "Cambio",
      fork: "Horquilla",
      weight: "Peso",
      dimensions: "Dimensiones"
    },
    
    // Footer
    footer: {
      tagline: "E-Bikes de Alta Calidad",
      categories: "Categorías",
      usefulLinks: "Enlaces Útiles",
      home: "Inicio",
      fullCatalog: "Catálogo Completo",
      store: "FreeWheel Store",
      bookAppointment: "Reservar Cita",
      contacts: "Contactos",
      allRightsReserved: "Todos los derechos reservados",
      distributedBy: "Distribuido por"
    },
    
    // Badges
    badges: {
      promo: "OFERTA",
      top: "TOP"
    },
    
    // Compare Feature
    compare: {
      title: "Comparar Bicicletas",
      selectBike: "Selecciona una bici",
      searchPlaceholder: "Buscar por nombre o categoría...",
      addBike: "Añadir Bici",
      viewDetails: "Ver Detalles",
      keySpecs: "Especificaciones Clave",
      dimensions: "Dimensiones",
      features: "Características",
      selected: "Seleccionadas",
      clear: "Borrar",
      compareNow: "Comparar",
      add: "Comparar",
      added: "Añadida"
    },
    
    // Bikes Content
    bikes: {
      navy: {
        tagline: "Fuerte, Imponente y Lista para Todo",
        description: "NAVY es una fatbike de espíritu agresivo y diseño robusto, pensada para quienes buscan presencia, estabilidad y estilo. El sillín alargado proporciona un aspecto distintivo y mayor comodidad.",
        color: "Azul Naval / Blanco",
        features: ["Sillín alargado", "Amortiguador central", "Pantalla LCD a color", "Homologada"]
      },
      commando: {
        tagline: "Espíritu Agresivo, Diseño Robusto",
        description: "COMMANDO es una fatbike de espíritu agresivo y diseño robusto, pensada para quienes buscan presencia, estabilidad y estilo. Ruedas extra anchas y construcción sólida para cualquier superficie.",
        color: "Amarillo / Blanco - Rojo",
        features: ["Sillín personalizado", "Amortiguador central", "Pantalla LCD a color", "Cadena KMC 7V"]
      },
      terram: {
        tagline: "Rendimiento Superior",
        description: "TERRAM es una e-MTB pensada para quienes quieren ir más allá del uso urbano, combinando comodidad, control y capacidad para afrontar senderos y pistas. Componentes premium RockShox y SRAM.",
        color: "Gris / Blanco",
        features: ["Amortiguador RockShox DELUXE", "Tija telescópica 150mm", "Sillín SELLE ROYAL", "Motor central"]
      },
      roktar: {
        tagline: "MTB Polivalente",
        description: "ROKTAR es una e-MTB para usuarios que buscan una experiencia polivalente fuera del asfalto. Equilibrada y accesible para disfrutar de la montaña sin complicaciones.",
        color: "Rojo/Negro - Negro/Naranja",
        features: ["Pantalla LCD a color", "Sillín confortable", "Cadena KMC 8V", "Horquilla 160mm"]
      },
      "roktar-plus": {
        tagline: "MTB Polivalente Potenciada",
        description: "ROKTAR Plus es la versión potenciada de la e-MTB Roktar. Motor de 80 Nm para afrontar subidas exigentes y senderos técnicos con mayor facilidad.",
        color: "Rojo/Negro - Negro/Naranja",
        features: ["Motor potenciado 80 Nm", "Pantalla LCD a color", "Sillín confortable", "Horquilla 160mm"]
      },
      zhepir: {
        tagline: "Versatilidad Total",
        description: "ZHEPIR está pensada para quienes buscan una experiencia polivalente entre senderos tranquilos, pistas de tierra y uso recreativo. Conducción cómoda, estable y fácil de controlar.",
        color: "Verde Militar - Azul",
        features: ["Pantalla LCD a color", "Sillín confortable", "Horquilla EXSHO", "2 colores disponibles"]
      },
      "zhepir-plus": {
        tagline: "Versatilidad Total Potenciada",
        description: "ZHEPIR X+Plus es la versión potenciada de la MTB Zhepir. Motor de 80 Nm para afrontar cualquier terreno con potencia superior.",
        color: "Azul - Verde Militar",
        features: ["Motor potenciado 80 Nm", "Pantalla LCD a color", "Sillín confortable", "2 colores disponibles"]
      },
      arenox: {
        tagline: "Elegancia Urbana",
        description: "ARENOX es una ebike urbana que prioriza la comodidad, facilidad de uso y conducción estable en entornos urbanos. Perfecta para el commuting diario.",
        color: "Perlado - Cobre",
        features: ["Diseño elegante", "Sillín confortable", "2 colores disponibles", "Pantalla LCD a color"]
      },
      "arenox-plus": {
        tagline: "Elegancia Urbana Potenciada",
        description: "ARENOX X+Plus es la versión potenciada de la ebike urbana Arenox. Mayor par y prestaciones superiores para quienes buscan el máximo confort en la ciudad.",
        color: "Cobre - Perlado",
        features: ["Motor potenciado 80 Nm", "Diseño elegante", "Sillín confortable", "Pantalla LCD a color"]
      },
      ventix: {
        tagline: "Confort Diario",
        description: "VENTIX es una ebike urbana pensada para el día a día, diseñada para desplazamientos cómodos, prácticos y eficientes por la ciudad.",
        color: "Gris/Rojo - Gris/Azul",
        features: ["Posición erguida", "Sillín confortable", "2 colores disponibles", "Pantalla LCD a color"]
      },
      "ventix-plus": {
        tagline: "Confort Diario Potenciado",
        description: "VENTIX X+Plus es la versión potenciada de la ebike urbana Ventix. Mayor par para afrontar cuestas y trayectos exigentes con facilidad.",
        color: "Gris/Azul - Gris/Rojo",
        features: ["Motor potenciado 80 Nm", "Posición erguida", "Sillín confortable", "Pantalla LCD a color"]
      },
      granit: {
        tagline: "Fatbike Plegable",
        description: "GRANIT es una fatbike plegable diseñada para ofrecer máxima comodidad sin renunciar a la fuerza. Cuadro abierto para subir y bajar fácilmente.",
        color: "Blanca",
        features: ["Cuadro abierto", "Sistema de plegado rápido", "Sillín confortable", "Fat Tire 20×4"]
      },
      lithor: {
        tagline: "Fuerza y Practicidad",
        description: "LITHOR es una fatbike plegable que combina fuerza, comodidad y funcionalidad. Domina terrenos irregulares como arena, nieve o tierra con facilidad.",
        color: "Crema - Gris - Turquesa",
        features: ["Sistema de plegado rápido", "Sillín confortable", "Fat Tire 20×4", "Diseño retro"]
      },
      brave: {
        tagline: "Aventura Sin Límites",
        description: "BRAVE es una fatbike plegable con suspensión que lleva la aventura a otro nivel. Comodidad, potencia y libertad en un único diseño.",
        color: "Naranja / Gris",
        features: ["Amortiguador central", "Sistema de plegado", "Sillín confortable", "Suspensión completa"]
      }
    }
  }
};

// Language metadata
export const languages = [
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
];

export default translations;
